// src/components/orders/wizard/PaymentStep.js
import React from 'react';
import { CreditCard, ArrowRight, ArrowLeft } from 'lucide-react';
import PaymentMethodSelector from '../PaymentMethodSelector';

const PaymentStep = ({ 
  data, 
  updateData, 
  validateStep,
  validations, 
  nextStep, 
  prevStep 
}) => {
  const handlePaymentMethodChange = (method) => {
    updateData({ paymentMethod: method });
    setTimeout(() => validateStep(3, validations.payment), 100);
  };

  const calculateSubtotal = () => {
    return data.orderItems?.reduce((sum, item) => sum + item.imponibile, 0) || 0;
  };

  const isValid = validations.payment(data);

  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <div className="text-center mb-6 lg:mb-8">
        <div className="w-16 h-16 lg:w-20 lg:h-20 rounded-full flex items-center justify-center mx-auto mb-4" style={{backgroundColor: '#fcfbd6'}}>
          <CreditCard className="w-8 h-8 lg:w-10 lg:h-10" style={{color: '#c48f75'}} />
        </div>
        <h2 className="text-xl lg:text-2xl font-bold text-gray-900 mb-2">
          Modalità di Pagamento
        </h2>
        <p className="text-gray-600 text-sm lg:text-base">
          Scegli come preferisci pagare per ottenere eventuali sconti
        </p>
      </div>

      <div className="max-w-4xl mx-auto">
        <PaymentMethodSelector
          selectedPaymentMethod={data.paymentMethod}
          onPaymentMethodChange={handlePaymentMethodChange}
          subtotal={calculateSubtotal()}
        />

        {/* Navigation */}
        <div className="flex justify-between items-center mt-8 pt-6 border-t border-gray-200">
          <button
            onClick={prevStep}
            className="flex items-center space-x-2 border border-gray-300 text-gray-700 px-4 sm:px-6 lg:px-8 py-3 rounded-xl font-medium hover:bg-gray-50 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Indietro</span>
          </button>

          <button
            onClick={() => {
              if (isValid) {
                validateStep(3, validations.payment, data);
                nextStep();
              }
            }}
            disabled={!isValid}
            className={`flex items-center space-x-2 px-4 sm:px-6 lg:px-8 py-3 rounded-xl font-medium transition-all ${
              isValid
                ? 'text-white shadow-lg'
                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
            }`}
            style={isValid ? {backgroundColor: '#c48f75'} : {}}
            onMouseEnter={(e) => isValid && (e.target.style.backgroundColor = '#4c4849')}
            onMouseLeave={(e) => isValid && (e.target.style.backgroundColor = '#c48f75')}
          >
            <span>Continua al Riepilogo</span>
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentStep;

